import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  setMultiSubcategoryPurchaseLimitsFlag,
  MULTI_SUBCATEGORY_PURCHASE_LIMITS_FLAG,
} from 'state/purchase-limits-flag';

export default function usePurchaseLimitsFlagsController(): void {
  const flags = useFlags();
  const rawFlagValue = flags[MULTI_SUBCATEGORY_PURCHASE_LIMITS_FLAG];

  useEffect(() => {
    setMultiSubcategoryPurchaseLimitsFlag(rawFlagValue);
  }, [rawFlagValue]);
}
